import { Module, Action, getModule } from 'vuex-module-decorators';
import EntityBaseModule from '@/store/entity';
import store from '@/store';
import { PartnerGroupModel } from '@/types/models/partnerGroups';
import EntityModel from './entityModel';
import { PartnerGroups } from '@/models/partnerGroups';
import { getById, addNewEntity, updateEntity, removeEntity } from '@/api/crud';
import { PartnerGroupRequest } from '@/types/models/partnerGroups';

export const MODULE_NAME = PartnerGroups.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PartnerGroupEntityModule extends EntityBaseModule {
    model: PartnerGroupModel;

    constructor(module: PartnerGroupEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(PartnerGroups.apiPrefix, id);

            return result.group;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async createNew(data: PartnerGroupRequest) {
        return addNewEntity(PartnerGroups.apiPrefix, data);
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: PartnerGroupRequest }) {
        return updateEntity(PartnerGroups.apiPrefix, params.id, params.data);
    }

    @Action({ rawError: true })
    async remove(id: string) {
        return removeEntity(PartnerGroups.apiPrefix, id);
    }

    @Action({ rawError: true })
    async getIsActive(id: string) {
        const result = await this.getById(id);
        return result.isActive;
    }
}

export default getModule(PartnerGroupEntityModule);
